import { types } from "../constants/types";

export const setContactFrame = (data) => (dispatch) => {
  console.log(data);
      dispatch({
        type: types.SET_FRAME,
        payload: data,
      });
};